import {takeEvery} from 'redux-saga/effects'
import {GET_SMS_LOG, GET_SMS_LOGS} from 'setup/redux/Actions/SmsLog/components/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  // Category
  yield takeEvery(GET_SMS_LOGS, fetchData)
  yield takeEvery(GET_SMS_LOG, fetchData)
}

export default dataSaga
